var React = require('react');

function BurgerMenuCross (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n    ")),React.createElement("path",{"id":"Path_Copy","data-name":"Path Copy","className":"cls-1","d":"M0,0,12.267,12.522","transform":"translate(5.367 2.778)","key":1}),React.createElement("path",{"id":"Path_Copy-2","data-name":"Path Copy","className":"cls-1","d":"M-3.733,0-16,12.522","transform":"translate(21.367 2.778)","key":2})]);
}

BurgerMenuCross.defaultProps = {"id":"mobile_burgermenu_cross","data-name":"mobile/burgermenu/cross","width":"23","height":"18","viewBox":"0 0 23 18"};

module.exports = BurgerMenuCross;

BurgerMenuCross.default = BurgerMenuCross;
